export const isPackageActive = (validTill: string | undefined): boolean => {
  const currentDate = new Date();
  const expiryDate = new Date(validTill || "");

  // Check if the current date is before the expiry date
  return currentDate < expiryDate;
};

export const gcToInr = (coin: number, conversionRate) => {
  return Math.floor(coin * (conversionRate.inrValue / conversionRate.gcValue));
};

export const inrToGc = (amount: number, conversionRate) => {
  return Math.floor(
    amount * (conversionRate.gcValue / conversionRate.inrValue)
  );
};

export const isBeforeTheTimeAndDate = function (date: Date | string): boolean {
  const inputDate = new Date(date);
  const cutoffDate = new Date("2025-07-04T16:09:00"); // YYYY-MM-DDTHH:mm:ss (24-hour format)
  return inputDate.getTime() < cutoffDate.getTime();
};
